import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { BuildingGroupSelectFormikField } from '../../BuildingGroup'
import { DOC_FLOW_FORM_FIELD_BUILDING_GROUPS } from '../DocFlow.constants'
import { getDocFlowScopeBuildingGroupApiParams } from '../DocFlow.utils.scope'

import { DOC_FLOW_SCOPE_BUILDING_GROUPS_FIELD_QA_NAME } from './DocFlowScopeBuildingGroupsField.constants'

function DocFlowScopeBuildingGroupsField({
  controlProps,
  fieldComponentProps,
  label,
  name = DOC_FLOW_FORM_FIELD_BUILDING_GROUPS,
  ...restProps
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  return (
    <BuildingGroupSelectFormikField
      {...restProps}
      apiParams={getDocFlowScopeBuildingGroupApiParams(values)}
      controlProps={{
        ...controlProps,
        contentProps: {
          inputProps: {
            placeholder: t('DocFlow.FormBuildingGroupsFieldPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        ...fieldComponentProps,
        info: t('DocFlow.FormBuildingGroupsFieldInfoKey'),
        label: label ?? t('DocFlow.FormBuildingGroupsFieldLabelKey'),
      }}
      name={name}
      qaName={DOC_FLOW_SCOPE_BUILDING_GROUPS_FIELD_QA_NAME}
    />
  )
}

export default DocFlowScopeBuildingGroupsField
